import { Typography, Checkbox } from "@mui/material"
import React from "react"

const FilterModal = ({selected, setSelected, date, setDate}: any) => {
    return (
        <div>
            <Typography variant="h5" sx={{ mb: 3 }}> Filter Interested Workers</Typography>
            <div className="margin-left">
                <div style={{display: "flex"}}>
                    <div className="availability-type">
                        <Checkbox className="transform" size="small" checked={selected === 0} onChange={() => setSelected(0)} />&nbsp; All Day
                    </div>
                    <div className="availability-type">
                        <Checkbox className="transform" size="small" checked={selected === 1} onChange={() => setSelected(1)} />&nbsp; Day
                    </div>
                    <div className="availability-type">
                        <Checkbox className="transform" size="small" checked={selected === 2} onChange={() => setSelected(2)} />&nbsp; Night
                    </div>
                </div>
            </div>
            {/* <div className="calendar">
                <DateRange
                    editableDateInputs={false}
                    onChange={item => setDate([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                />
            </div> */}
        </div>
    );
}

export default FilterModal;
